import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ec9fb86"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "book-button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseDropdown = _resolveComponent("BaseDropdown")!
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createElementBlock("form", {
    class: "quickform-form",
    onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
  }, [
    _createVNode(_component_BaseDropdown, {
      modelValue: _ctx.v$.modeOfTravel.$model,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.modeOfTravel.$model) = $event)),
      options: _ctx.typeOfTravel,
      insideLabel: "Mode of travel",
      name: "modeOfTravel",
      next: _ctx.leavingFrom,
      onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.open(_ctx.leavingFrom)))
    }, null, 8, ["modelValue", "options", "next"]),
    _createVNode(_component_BaseDropdown, {
      insideLabel: "Leaving from",
      modelValue: _ctx.from,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.from) = $event)),
      options: _ctx.outwardOptions,
      name: "leavingFrom",
      ref: "leavingFrom",
      next: _ctx.goingTo,
      onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.open(_ctx.goingTo)))
    }, null, 8, ["modelValue", "options", "next"]),
    _createVNode(_component_BaseDropdown, {
      insideLabel: "Going to",
      modelValue: _ctx.to,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.to) = $event)),
      options: _ctx.returnOptions,
      name: "goingTo",
      ref: "goingTo",
      next: _ctx.monthRef,
      onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.open(_ctx.monthRef)))
    }, null, 8, ["modelValue", "options", "next"]),
    _createVNode(_component_BaseDropdown, {
      insideLabel: "Month",
      ref: "monthRef",
      options: _ctx.monthOptions,
      modelValue: _ctx.v$.month.$model,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.v$.month.$model) = $event))
    }, null, 8, ["options", "modelValue"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_BaseButton, { loading: _ctx.loading }, {
        default: _withCtx(() => [
          _createTextVNode("View")
        ]),
        _: 1
      }, 8, ["loading"])
    ])
  ], 32))
}